<template>
  <Modal id="changepassword" data-bs-backdrop="static" class="modal-status">
    <template #header color="dark">
      <h5 class="modal-title">{{ $t('key_change_password') }}</h5>
    </template>
    <template #body>
      <div class="row">
        <form ref='editForm' class="needs-validation" novalidate>
          <div class="row mb-4">
            <div class="col-sm-12">
              <label class="form-label text-primary">{{ $t('key_current_password') }} <span style="color:red">*</span></label>
              <div class="input-group">
                <input
                  v-model="user.password"
                  :type="!icons.showCurrentPassword ? 'password' : 'text'"
                  class="form-control"
                  placeholder=""
                  aria-label="Current password"
                  name="currentPassword"
                  required
                >
                <button
                  id="button-current-password"
                  class="btn btn-outline-secondary btn-form"
                  type="button"
                  @click="icons.showCurrentPassword = !icons.showCurrentPassword"
                >
                  <i :class="{
                    'fa fa-eye-slash': !icons.showCurrentPassword,
                    'fa fa-eye': icons.showCurrentPassword,
                  }" />
                </button>
                <div class="invalid-feedback">
                  {{ $t('key_type_current_password') }}
                </div>
              </div>
            </div>
          </div>
           <div class="row mb-4">
            <div class="col-sm-12">
              <label class="form-label text-primary">{{ $t('key_new_password') }} <span style="color:red">*</span></label>
              <div class="input-group">
                <input
                  id="newPassword"
                  v-model="user.newPassword"
                  :type="!icons.showNewPassword ? 'password' : 'text'"
                  class="form-control"
                  aria-label="New password"
                  name="newPassword"
                  required
                  @input="validatePassowordFields($event, 'new-password-message')"
                >
                <button
                  id="button-new-password"
                  class="btn btn-outline-secondary btn-form"
                  type="button"
                  @click="icons.showNewPassword = !icons.showNewPassword"
                >
                  <i :class="{
                    'fa fa-eye-slash': !icons.showNewPassword,
                    'fa fa-eye': icons.showNewPassword,
                  }" />
                </button>
                <div class="invalid-feedback">
                  {{ $t('key_type_new_password') }}
                </div>
                <div id="new-password-message" class="password-invalid-feedback">
                  {{ $t('key_new_password_message_error') }}
                </div>
                <div v-if="coincidenceNewPassword" class="password-coincidence-feedback">
                  {{ $t('key_passwords_missmatch_error') }}
                </div>
              </div>
            </div>
          </div>
           <div class="row mb-3">
            <div class="col-sm-12">
              <label class="form-label text-primary">{{ $t('key_confirm_password') }} <span style="color:red">*</span></label>
              <div class="input-group">
                 <input
                  id="confirmPassword"
                  v-model="user.confirmPassword"
                  :type="!icons.showConfirmPassword ? 'password' : 'text'"
                  class="form-control"
                  placeholder=""
                  aria-label="Confirm password"
                  name="confirmPassword"
                  required
                  @input="validatePassowordFields($event, 'confirm-password-message')"
                >
                <button
                  id="button-confirm-password"
                  class="btn btn-outline-secondary btn-form"
                  type="button"
                  @click="icons.showConfirmPassword = !icons.showConfirmPassword"
                >
                  <i :class="{
                    'fa fa-eye-slash': !icons.showConfirmPassword,
                    'fa fa-eye': icons.showConfirmPassword,
                  }" />
                </button>
                <div class="invalid-feedback">
                  {{ $t('key_password_confirmation_required') }}
                </div>
                <div id="confirm-password-message" class="password-invalid-feedback">
                  {{ $t('key_new_password_message_error') }}
                </div>
                <div v-if="coincidenceConfirmPassword" class="password-coincidence-feedback">
                  {{ $t('key_passwords_missmatch_error') }}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>
    <template #footer>
      <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal" @click="resetForm">
        {{ $t('key_close') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" @click="saveNewPassoword">
        {{ $t('key_submit') }}
      </button>
    </template>
  </Modal>
    <div class="position-fixed top-8 end-2 notification">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
</template>
<script>
import Modal from "@/components/ModalHotakauth.vue";
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import { stopCrataWidget } from "@/plugins/CrataWidget";
export default {
  components: { Modal, SoftSnackbar},
  data() {
    return {
      user: {
        user: "",
        password: "",
        newPassword: "",
        confirmPassword: "",
      },
      notificationInfo: {
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
      icons: {
        showCurrentPassword: false,
        showNewPassword: false,
        showConfirmPassword: false,
      },
      passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*)(+=._-]{8,}$/,
      coincidenceNewPassword: false,
      coincidenceConfirmPassword: false,
      localUser: null,
    };
  },
  computed: {
    changePassword() {
      return this.$store.state.user.editPass.status;
    },
  },
  watch: {
    changePassword() {
      if (this.$store.state.user.editPass.status.edited) {
        this.notificationInfo = {
          title: 'Correcto!',
          message: "Tu contraseña ha sido cambiada correctamente!",
          status: 'success'
        }
        this.showNotification = true
        setTimeout(() => {
          stopCrataWidget();
          localStorage.removeItem("user");
          //localStorage.removeItem("empleado");
          this.$router.push({ name: "Login page" });
        }, 500);
        this.closeModal()
        this.closeNotification()
      } else if (this.$store.state.user.editPass.status.error) {
        let response = this.$store.state.user.editPass.status.error
        this.notificationInfo = {
          title: 'Ups! Error',
          message: response["error"],
          status: 'error'
        }
        setTimeout(() => {
          this.showNotification = true;
          this.closeNotification()
        }, 1400)
      }
    },
  },
  mounted() {
    this.localUser = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    closeNotification() { 
      setTimeout(() => {
        this.showNotification = false
      }, 1600);
    },
    closeModal() {
      let modal = document.getElementById("changepassword")
      let modaBackdrop = document.getElementsByClassName("modal-backdrop")[0]
      modal.classList.remove('show');
      modaBackdrop.remove();
    },
    resetForm() {
      this.user = {
        user: "",
        password: "",
        newPassword: "",
        confirmPassword: "",
      }

      let form = this.$refs.editForm;
      form.classList.remove('was-validated')
    },
    saveNewPassoword($event) {
      if (this.coincidenceNewPassword && this.coincidenceConfirmPassword) {
        $event.preventDefault();
      }
      let form = this.$refs.editForm;
      if (form.checkValidity()) {
        this.user.user = this.localUser.user;
        this.user.userId = this.localUser.userId;
        this.$store.commit("user/changePassword", this.user);
        return
      }
      form.classList.add('was-validated')
    },
    validatePassowordFields($event, messageHtmlId) {
      let value = $event.target.value
      let form = this.$refs.editForm;
      let message = document.getElementById(messageHtmlId)
      if (!value.match(this.passwordRegex)) {
        $event.target.classList.add("password-invalid-feedback-input")
        message.style.display = "block"
        this.coincidenceNewPassword = false;
        form.classList.remove('was-validated')
        return
      }

      message.style.display = "none"
      $event.target.classList.remove("password-invalid-feedback-input")
      form.classList.add('was-validated')
      let inputName = $event.target.name;

      if (inputName == "newPassword") {
        if (this.user.newPassword != this.user.confirmPassword && this.user.confirmPassword != "") {
          $event.target.classList.add("password-invalid-feedback-input")
          form.classList.remove('was-validated')
          this.coincidenceNewPassword = true;
          return
        }
        if (this.user.newPassword == this.user.confirmPassword && this.user.confirmPassword != "") {
          this.coincidenceConfirmPassword = false;
          this.coincidenceNewPassword = false;
          document.getElementById("confirmPassword").classList.remove("password-invalid-feedback-input")
        } else {
          this.coincidenceNewPassword = false;
        }
        return
      }

      if (inputName == "confirmPassword") {
        if (this.user.newPassword != this.user.confirmPassword && this.user.newPassword != "") {
          $event.target.classList.add("password-invalid-feedback-input")
          form.classList.remove('was-validated')
          this.coincidenceConfirmPassword = true;
          return
        }
        if (this.user.newPassword == this.user.confirmPassword && this.user.newPassword != "") {
          this.coincidenceConfirmPassword = false;
          this.coincidenceNewPassword = false;
          document.getElementById("newPassword").classList.remove("password-invalid-feedback-input")
        } else {
          this.coincidenceConfirmPassword = false;
        }
        return
      }
    }
  },
};
</script>
<style scoped>
.modal-status .modal-container {
  width: 500px !important;
}

.btn-form {
  margin-bottom: 0rem;
}

.notification {
  z-index: 100050 !important;
}

.password-coincidence-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #fd5c70;
}

.password-invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #fd5c70;
}

.password-invalid-feedback-input {
  border-color: #fd5c70 !important;
  padding-right: unset !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23fd5c70' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fd5c70' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.75rem center !important;
  background-size: 1rem 1rem !important;
}
</style>